import {EventEmitter} from 'events';

export const eventEmitter = new EventEmitter();

export enum CustomEvents {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    GLOBALMESSAGE = 'GLOBALMESSAGE'
}

